<template>
  <div>
    <catalog-table
      :tableHeaders="customerHeaders"
      :tableData="customers"
      :tableFilters="customerFilters"
      :propsToSearch="customerSearchableProps"
      :actions="customerActions"
      :pageSize="100"
      hidePageSize
      hideFooter
    >
      <md-avatar slot="logo-cell" slot-scope="{ value }">
        <img-with-fallback class="img" :src="value" />
      </md-avatar>

      <template v-if="$can('add', 'Customer', 'customer')" slot="search-toolbar-actions">
        <md-button class="md-success" @click="addCustomer">
          <span class="md-label">
            <md-icon class="material-icons">add</md-icon>
          </span>
          Agregar
        </md-button>
      </template>
    </catalog-table>
    <!-- -->
    <modal v-if="editModal" @close="editModalHide">
      <template slot="body">
        <customer-edit
          :customer="this.currentCustomer"
          :title="editModalTitle"
          @saved="updateCustomer"
          @error="hideEdit"
        ></customer-edit>
      </template>
    </modal>
  </div>
</template>

<script>
import catalogService from "@/services/catalog";
import { CatalogTable } from "@/components/";
import { Modal } from "@/components";
import { booleanToState } from "@/filters";
import CustomerEdit from "./Edit";

export default {
  name: "Customers",
  components: {
    CatalogTable,
    Modal,
    CustomerEdit,
  },

  data() {
    return {
      customers: [],
      editModal: false,
      currentCustomer: {},
      editModalTitle: "Editar Cliente",
      customerHeaders: {
        logo: "Logo",
        codename: "Nombre clave",
        name: "Nombre",
        customerTypeName: "Tipo",
      },
      customerFilters: {
        isActive: booleanToState,
      },
      customerSearchableProps: ["name"],
      customerActions: [
        {
          icon: "edit",
          // exe: this.editCustomer
          exe: (customer) => {
            this.$router.push({ path: `/clientes/${customer.id}` });
          },
          showIf: () => this.$can("change", "Customer", "customer"),
        },
        {
          icon: "close",
          exe: this.deleteCustomer,
          showIf: () => this.$can("delete", "Customer", "customer"),
        },
      ],
    };
  },
  methods: {
    editModalHide() {
      this.editModal = false;
    },
    editCustomer(c) {
      this.editModalTitle = "Editar cliente";
      this.currentCustomer = c;
      this.editModal = true;
    },
    deleteCustomer(c) {
      this.$confirmMessage(
        { title: `¿Está seguro que desea borrar ${c.name}?` },
        () => {
          return catalogService
            .delete("customer", c, { source: this.customers })
            .then(() => this.$successMessage({ title: "Borrado" }))
            .catch(this.$fireErrorResponse);
        }
      );
    },
    updateCustomer({ original, updated }) {
      this.hideEdit();
      if (!original.id) {
        catalogService
          .create("customer", updated, { source: this.customers })
          .then((customer) =>
            this.$successMessage({
              title: `Creado nuevo cliente: ${customer.name}`,
            })
          )
          .catch(this.$fireErrorResponse);
      } else {
        catalogService
          .update("customer", updated, original, { source: this.customers })
          .then(
            (customer) =>
              this.$successMessage({
                title: `${customer.name} fue actualizado.`,
              }),
            this.$fireErrorResponse
          );
      }
    },
    addCustomer() {
      this.$router.push({ path: `/clientes/nuevo` });
    },
    hideEdit() {
      this.editModal = false;
    },
  },
  mounted() {
    catalogService
      .fetch("customer")
      .then((customers) => (this.customers = customers));
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Customers/Index.vue